import { render, staticRenderFns } from "./resellers_calendar.vue?vue&type=template&id=5452cb17&"
import script from "./resellers_calendar.vue?vue&type=script&lang=js&"
export * from "./resellers_calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports